export default "__VITE_ASSET__qSS07HH1__"